import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Attachments_overview extends PureComponent {
  render() {
    return (
      <div className="row" id="attachments_overview">
        <div className="col-md-6 ">
          <div className="contentLight">
            <section>
              <h2>Attachments Overview</h2>

              <p>
                Nexoid API uses Amazon’s AWS S3 for file storage. This gives you
                effectively unlimited file storage. AWS S3 works by giving
                temporary public URLs to secure files. Attached files are locked
                to a record. For a user to download a file they will need read
                access to that record and the file download permission. For more
                information consult the security and permissions section of this
                website.{" "}
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol ">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Attachments_overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Attachments_overview.js